export * from './cartaoDeprecated';
export * from './enderecoDeprecated';
export * from './item';
export * from './session';
export * from './subject';
export * from './telefone-celular';
export * from './telefone-comercial';
export * from './telefone-residencial';
export * from './define-bootbox-id';



// WEBPACK FOOTER //
// ./src/app/resources/classes/index.ts